import { api } from "./api";

const KEY = "et_chat_session";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getSessionId = () => {
  let sid = localStorage.getItem(KEY);
  if (!sid) {
    sid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`).replace(/[^A-Za-z0-9-]/g, "");
    localStorage.setItem(KEY, sid);
  }
  return sid;
};

export const fetchHistory = (sid) => api.get(`/chat/history/${sid}`).then((r) => r.data.messages);

export const createLead = (body) => api.post("/chat/leads", body).then((r) => r.data);

export const streamChat = async (sid, message, onEvent) => {
  const res = await fetch(`${BASE}/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sid, message }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const d = data.detail;
    throw new Error(typeof d === "string" ? d : "Chat is unavailable right now.");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i).split("\n").find((l) => l.startsWith("data: "));
      buf = buf.slice(i + 2);
      if (line) onEvent(JSON.parse(line.slice(6)));
    }
  }
};
